<kendo-dialog class="standard-dialog"
  [hidden]="!showDialog()" title="Add Items"
  (close)="close()"
  [minWidth]="500"
  [width]="1024">

  <kendo-grid
    [hidden]="!showPhaseStep()"
    [data]="iDistinctPhaseStep()"
    [height]="250"
    [sort]="phaseStepSort"
    [sortable]="true"
    [kendoGridSelectBy]="'PSKey'"
    (sortChange)="phaseStepSortChange($event)"
    (selectionChange)="phaseSelectionChange($event)"
    [selectedKeys]="selectedPhaseStepKey">
    <kendo-grid-checkbox-column
      [reorderable]="false"
      [width]="40"
      [showSelectAll]="false">
    </kendo-grid-checkbox-column>
    <kendo-grid-column field="Phase" title="Phase">
    </kendo-grid-column>
    <kendo-grid-column field="Step" title="Step">
    </kendo-grid-column>
  </kendo-grid>

  <kendo-grid #grid appGridRClick
    [data]="view | async"
    [style.max-height]="'550px'"
    [pageSize]="state.take"
    [skip]="state.skip"
    [sort]="state.sort"
    [filter]="state.filter"
    [pageable]="true"
    [sortable]="true"
    [filterable]="true"
    [resizable]="true"
    [scrollable]="'scrollable'"
    (dataStateChange)="dataStateChange($event)"
    (selectionChange)="selectionChange($event)"
    [kendoGridSelectBy]="'ItemId'">

    <ng-template kendoGridToolbarTemplate>
      @if (this.itemGridService.loading) {
        <kendo-loader type="converging-spinner" size="small"></kendo-loader>
      }&nbsp;
    </ng-template>

    <kendo-grid-checkbox-column [reorderable]="false" [width]="40" [showSelectAll]="false"></kendo-grid-checkbox-column>

    <kendo-grid-column field="ItemCategory" title="Item Category" [width]="180">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell
          [showOperators]="false"
          [column]="column"
          [filter]="filter">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="ItemNumber" title="Item #" [width]="150">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell
          [showOperators]="false"
          [column]="column"
          [filter]="filter">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="GFCM" title="GFCM">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell
          [showOperators]="false"
          [column]="column"
          [filter]="filter">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="ItemDescription" title="Description">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell
          [showOperators]="false"
          [column]="column"
          [filter]="filter">
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>

  <div class="dialog-footer-actions">
    <button type="button" kendoButton
      themeColor="primary"
      [svgIcon]="icons.plusCircle"
      [disabled]="disableAdd()"
      (click)="addSelected()">Add</button>

    <button type="button" kendoButton
      themeColor="primary"
      [svgIcon]="icons.cancel"
      (click)="close()">Cancel</button>
  </div>
</kendo-dialog>